import { __awaiter } from "tslib";
import { useEffect, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
export const useGooglePlaces = (apiKey) => {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (!apiKey)
            return;
        const loader = new Loader({
            apiKey,
            version: 'weekly',
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loader.load().then(() => __awaiter(void 0, void 0, void 0, function* () {
            (yield window.google.maps.importLibrary('places'));
            setLoaded(true);
        }));
    }, [apiKey]);
    return { loaded };
};
export default useGooglePlaces;
//# sourceMappingURL=useGooglePlaces.js.map